import { createAsyncThunk } from "@reduxjs/toolkit";
import HelpDeskAPI, { helpDeskApiUrls } from "../API/HelpDeskAPI";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const helpDeskAPI = new HelpDeskAPI(apiHelper, cache);

export const getConnectionRequests = createAsyncThunk(
  helpDeskApiUrls.GetConnectionRequests,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await helpDeskAPI.getConnectionRequests(payload, token);

    return response;
  }
);

export const getHelpRequests = createAsyncThunk(
  helpDeskApiUrls.GetHelpRequests,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await helpDeskAPI.getHelpRequests(payload, token);

    return response;
  }
);

export const updateIsResolved = createAsyncThunk(
  helpDeskApiUrls.UpdateIsResolved,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await helpDeskAPI.updateIsResolved(payload, token);

    // dispatch(getHelpRequests());

    return response;
  }
);
